import { request } from '.';
import { setUiState } from './ui';

const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
const SET_ORGANIZATION = 'SET_ORGANIZATION';
const SET_ORGANIZATION_CONTACT_COUNTS = 'SET_ORGANIZATION_CONTACT_COUNTS';
const SET_ORGANIZATION_FORM_TOTAL_RESPONDENT =
  'SET_ORGANIZATION_FORM_TOTAL_RESPONDENT';
const SET_ORGANIZATION_TOTAL_REVENUE = 'SET_ORGANIZATION_TOTAL_REVENUE';
const SET_ORGANIZATION_EVENTS = 'SET_ORGANIZATION_EVENTS';
const SET_ORGANIZATION_FORMS = 'SET_ORGANIZATION_FORMS';
const SET_EMAIL_TEMPLATES = 'SET_EMAIL_TEMPLATES';
const SET_MEMBER_PLANS = 'SET_MEMBER_PLANS';
const SET_META = 'SET_META';

const defaultState = {
  memberPlans: null,
  forms: null,
  events: null,
  organizations: null,
  organization: null,
  businessMetrics: null,
  contactCounts: null,
  formTotalRespondent: null,
  totalRevenue: null,
  meta: null
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_ORGANIZATIONS:
      return { ...state, organizations: action.payload, organization: null };

    case SET_ORGANIZATION:
      return { ...state, organization: action.payload };

    case SET_ORGANIZATION_CONTACT_COUNTS:
      return { ...state, contactCounts: action.payload };

    case SET_ORGANIZATION_FORM_TOTAL_RESPONDENT:
      return { ...state, formTotalRespondent: action.payload };

    case SET_ORGANIZATION_TOTAL_REVENUE:
      return { ...state, totalRevenue: action.payload };

    case SET_MEMBER_PLANS:
      return { ...state, memberPlans: action.payload };

    case SET_ORGANIZATION_EVENTS:
      return { ...state, events: action.payload };

    case SET_ORGANIZATION_FORMS:
      return { ...state, forms: action.payload };

    case SET_EMAIL_TEMPLATES:
      return { ...state, templates: action.payload };

    case SET_META:
      return { ...state, meta: action.payload };

    default:
      return state;
  }
}

export function setOrganization(organization) {
  return {
    type: SET_ORGANIZATION,
    payload: organization
  };
}
export function setOrganizations(organizations) {
  return {
    type: SET_ORGANIZATIONS,
    payload: organizations
  };
}
export function setOrganizationContactCounts(counts) {
  return {
    type: SET_ORGANIZATION_CONTACT_COUNTS,
    payload: counts
  };
}
export function setOrganizationFormTotalRespondent(totalRespondent) {
  return {
    type: SET_ORGANIZATION_FORM_TOTAL_RESPONDENT,
    payload: totalRespondent
  };
}
export function setOrganizationTotalRevenue(totalRevenue) {
  return {
    type: SET_ORGANIZATION_TOTAL_REVENUE,
    payload: totalRevenue
  };
}
export function setOrganizationEvents(events) {
  return {
    type: SET_ORGANIZATION_EVENTS,
    payload: events
  };
}
export function setOrganizationForms(forms) {
  return {
    type: SET_ORGANIZATION_FORMS,
    payload: forms
  };
}
export function setEmailTemplates(templates) {
  return {
    type: SET_EMAIL_TEMPLATES,
    payload: templates
  };
}
export function setMemberPlans(plans) {
  return {
    type: SET_MEMBER_PLANS,
    payload: plans
  };
}
export function setMeta(meta) {
  return {
    type: SET_META,
    payload: meta
  };
}
export function getOrganization(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${id}`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        dispatch(setOrganization(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function updateOrganization(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${id}`;

        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function getOrganizations(
  limit,
  offset,
  sort_by,
  sort_order,
  search,
  admin
) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        let queryParams = [];
        if (sort_by) {
          queryParams.push(`sort_by=${sort_by}`);
        }
        if (sort_order) {
          queryParams.push(`sort_order=${sort_order}`);
        }
        if (search) {
          queryParams.push(`search=${search}`);
        }
        if (limit !== undefined) queryParams.push(`limit=${limit}`);
        if (offset !== undefined) queryParams.push(`offset=${offset}`);
        if (admin !== undefined) queryParams.push(`admin=${admin}`);
        const url = `/internal/organizations?${queryParams.join('&')}`;

        dispatch(setUiState('loading'));
        const response = await request.get(url);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }

        dispatch(setOrganizations(response.data));
        const meta = {
          count: Number(response.headers['juven-count']) || 0,
          from: Number(response.headers['juven-from']) || 0,
          to: Number(response.headers['juven-to']) || 0
        };
        dispatch(setMeta(meta));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function getOrganizationContactCounts(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/contacts/counts`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        const counts = response.data;
        dispatch(setUiState('complete'));
        dispatch(setOrganizationContactCounts(counts));
        return resolve(counts);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}
export function getOrganizationFormTotalRespondent(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/forms/total_respondents`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const totalRespondent = response.data;
        dispatch(setOrganizationFormTotalRespondent(totalRespondent.count));
        return resolve(totalRespondent);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}
export function getOrganizationTotalRevenue(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/total_revenue`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const totalRevenue = response.data;
        dispatch(setOrganizationTotalRevenue(totalRevenue));
        return resolve(totalRevenue);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}

export function getOrganizationEvents(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/events`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const events = response.data;
        dispatch(setOrganizationEvents(events));
        return resolve(events);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}

export function getOrganizationForms(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/forms`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const forms = response.data;
        dispatch(setOrganizationForms(forms));
        return resolve(forms);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}

export function getEmailTemplates(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/email_templates`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const templates = response.data;
        dispatch(setEmailTemplates(templates));
        return resolve(templates);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}
export function getMemberPlans(oId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/organizations/${oId}/members/plans`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);

        dispatch(setUiState('complete'));
        const plans = response.data;
        dispatch(setMemberPlans(plans));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}



// WEBPACK FOOTER //
// ./src/redux/organizations.js